import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SignInProps } from './types';
import styles from './styles';
import InputField from '../common/InputField/InputField';
import FormButton from '../common/FormButton';

const SignIn = ({ handleSubmit, formErrors, handleInput, credentials, submitting }: SignInProps) => {
    return (
        <Box>
            <Typography data-testid="diathrive_title" sx={styles.subTitle} component="div">
                Sign In To{' '}
                <Typography id="sign_in_title" sx={styles.title}>
                    Admin Portal
                </Typography>
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <InputField
                    required
                    id="email"
                    label="Email"
                    type="text"
                    name="email"
                    placeholder="Type here..."
                    onChange={handleInput}
                    error={formErrors && formErrors.email && formErrors.email[0] !== ''}
                    errorMessage={formErrors && formErrors.email && formErrors.email[0]}
                    value={credentials.email}
                />
                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <InputField
                        required
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        placeholder="Type here..."
                        onChange={handleInput}
                        error={formErrors && formErrors.password && formErrors.password[0] !== ''}
                        errorMessage={formErrors && formErrors.password && formErrors.password[0]}
                        autoComplete="password"
                        value={credentials.password}
                    />
                </Typography>
                {formErrors && formErrors.beError ? (
                    <Typography sx={styles.error_message}>{formErrors.beError}</Typography>
                ) : null}

                <Grid container sx={{ alignItems: 'center', mt: '24px' }}>
                    <Grid item md={6}>
                        <FormControlLabel
                            control={<Checkbox value="remember" color="primary" sx={styles.checkbox} />}
                            label={
                                <Typography id="sign_in_remember" variant="body2" sx={styles.remember_me}>
                                    Remember me next time.
                                </Typography>
                            }
                        />
                    </Grid>
                    <Grid item md={6} textAlign="right">
                        <Link id="forgot_password" href="/forgot-password" variant="body2" sx={styles.forgot_password}>
                            Forgot Password?
                        </Link>
                    </Grid>
                </Grid>
                <FormButton
                    id="sign_in"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={styles.signIn_Btn}
                    submitting={submitting}
                >
                    Sign In
                </FormButton>
            </Box>
        </Box>
    );
};

export default SignIn;
